import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import '../styles/NoteHighlighting.css';

// Styled components for GuitarNeckVisualizer

export const GuitarNeck = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  border: '1px solid rgba(255, 255, 255, 0.2)',
  borderRadius: '4px',
  overflow: 'hidden',
  backgroundColor: '#000000',
  width: '100%',
  className: 'guitar-neck-container'
}));

export const NoteMarker = styled(Box)(({ theme, isroot, ismodecolor, ispattern, isplaying }) => ({
  width: 'calc(var(--neck-note-size, 32px) - 2px)',
  height: 'calc(var(--neck-note-size, 32px) - 2px)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%', // All notes are circles
  color: '#FFFFFF',
  fontWeight: 700, // Bold for all notes
  fontSize: '0.8rem',
  zIndex: 10, // Higher z-index to ensure it appears above the string
  position: 'relative',
  cursor: 'pointer', // Add cursor pointer to indicate clickable
  boxShadow: '0 2px 4px rgba(0,0,0,0.5)', // Enhanced shadow for better visibility
  backgroundColor: '#000000', // Ensure solid black background
  className: 'note-marker'
}));

// Create a version of the NoteMarker that properly handles boolean props
// without passing them directly to the DOM
export const EnhancedNoteMarker = ({ isroot, ismodecolor, ispattern, isplaying, className, ...props }) => {
  // Convert boolean props to data attributes that won't trigger warnings
  const noteTypeClass = `enhanced-note-marker ${isroot ? 'root-note' : ''} ${ismodecolor ? 'mode-color-note' : ''} ${ispattern ? 'pattern-note' : ''} ${isplaying ? 'playing-note' : ''} ${className || ''}`;
  
  return (
    <NoteMarker
      className={noteTypeClass}
      data-isroot={isroot ? "true" : "false"}
      data-ismodecolor={ismodecolor ? "true" : "false"}
      data-ispattern={ispattern ? "true" : "false"}
      data-isplaying={isplaying ? "true" : "false"}
      {...props}
    />
  );
};

// Connection line between notes in the pattern
export const ConnectionLine = styled(Box)(({ theme, color }) => ({
  position: 'absolute',
  height: '3px',
  backgroundColor: 'rgba(65, 105, 225, 0.7)', // Slightly transparent blue for connection lines
  zIndex: 0,
  borderRadius: '1.5px', // Rounded edges for the connection lines
  className: 'connection-line'
}));
